var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHungary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 1.51265C22.3139 1.51313 22.6743 1.64637 22.9401 1.88317C23.2059 2.11996 23.3555 2.44099 23.356 2.77587V20.482C23.3555 20.8169 23.2059 21.1379 22.9401 21.3747C22.6743 21.6115 22.3139 21.7447 21.938 21.7452H2.06201C1.6861 21.7447 1.32572 21.6115 1.05991 21.3747C0.7941 21.1379 0.644523 20.8169 0.643994 20.482V2.77587C0.644523 2.44099 0.7941 2.11996 1.05991 1.88317C1.32572 1.64637 1.6861 1.51313 2.06201 1.51265H21.938ZM21.938 0.938965H2.06201C1.5153 0.939437 0.991126 1.13313 0.604541 1.47751C0.217956 1.82189 0.000529505 2.28884 0 2.77587V20.482C0.000529505 20.969 0.217956 21.436 0.604541 21.7803C0.991126 22.1247 1.5153 22.3184 2.06201 22.3189H21.938C22.4845 22.3179 23.0084 22.1241 23.3949 21.7798C23.7813 21.4355 23.9989 20.9689 24 20.482V2.77587C23.9995 2.28884 23.782 1.82189 23.3955 1.47751C23.0089 1.13313 22.4847 0.939437 21.938 0.938965Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643951 20.4821C0.644481 20.817 0.794057 21.138 1.05987 21.3748C1.32568 21.6116 1.68605 21.7449 2.06197 21.7453H21.9379C22.3139 21.7449 22.6742 21.6116 22.94 21.3748C23.2059 21.138 23.3554 20.817 23.356 20.4821V15.1924H0.643951V20.4821Z",
    fill: "#19704A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.356 8.06543H0.643951V15.1921H23.356V8.06543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 1.5127H2.06197C1.68605 1.51317 1.32568 1.64641 1.05987 1.88321C0.794057 2.12 0.644481 2.44103 0.643951 2.77591V8.06564H23.356V2.77591C23.3554 2.44103 23.2059 2.12 22.94 1.88321C22.6742 1.64641 22.3139 1.51317 21.9379 1.5127Z",
    fill: "#E5253A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.938965)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungary);
export default __webpack_public_path__ + "static/media/Hungary.e819effbdd7830530fb82bc552c2b317.svg";
export { ForwardRef as ReactComponent };